import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { eiendomAPI, rapportAPI } from '../services/api';
import './Befaring.css';

function Kontrollsenter() {
  const { eiendomId } = useParams();
  const navigate = useNavigate();
  const [eiendom, setEiendom] = useState(null);
  const [validering, setValidering] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchData();
  }, [eiendomId]);

  const fetchData = async () => {
    try {
      setLoading(true);

      // Hent eiendom
      const eiendomResp = await eiendomAPI.getById(eiendomId);
      setEiendom(eiendomResp.data);

      // Hent validering
      const valideringResp = await rapportAPI.valider(eiendomId);
      setValidering(valideringResp.data);

    } catch (err) {
      setError('Kunne ikke laste data: ' + (err.response?.data?.error || err.message));
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="container"><p>Laster kontrollsenter...</p></div>;
  if (error) return <div className="container"><div className="error-message">{error}</div></div>;
  if (!eiendom || !validering) return <div className="container"><p>Ingen data</p></div>;

  const antallMangler = validering.feil?.length || 0;
  const erKlar = validering.erKlar;

  return (
    <div className="container">
      <div className="page-header">
        <button onClick={() => navigate(`/eiendom/${eiendomId}`)} className="btn-back">
          ← Tilbake
        </button>
        <h1>🎯 Kontrollsenter</h1>
      </div>

      {/* Status oversikt */}
      <div style={{
        padding: '20px',
        marginBottom: '30px',
        backgroundColor: erKlar ? '#e8f5e9' : '#fff3e0',
        border: `2px solid ${erKlar ? '#4caf50' : '#ff9800'}`,
        borderRadius: '8px'
      }}>
        <h2 style={{ marginTop: 0, color: erKlar ? '#2e7d32' : '#f57c00' }}>
          {erKlar ? '✅ Rapport klar for generering' : '⚠️ Rapport har mangler'}
        </h2>

        <div style={{ fontSize: '18px', marginTop: '15px' }}>
          <strong>Eiendom:</strong> {eiendom.adresse}
        </div>

        <div style={{ fontSize: '16px', marginTop: '10px' }}>
          <strong>Fremdrift:</strong> {validering.prosent}% fullført
        </div>

        {!erKlar && (
          <div style={{
            marginTop: '15px',
            padding: '15px',
            backgroundColor: '#fff',
            borderRadius: '4px',
            border: '1px solid #ff9800'
          }}>
            <strong style={{ color: '#e65100' }}>
              ⚠️ {antallMangler} {antallMangler === 1 ? 'mangel' : 'mangler'} må utbedres før rapport kan genereres
            </strong>
          </div>
        )}
      </div>

      {/* Liste over mangler */}
      {!erKlar && validering.feil && validering.feil.length > 0 && (
        <div style={{ marginBottom: '30px' }}>
          <h2>📋 Mangler som må utbedres</h2>

          {validering.feil.map((feil, index) => {
            const bygningMatch = feil.bygning?.match(/^(.*?)\s*\(bygning \d+\)$/);
            const bygningNavn = bygningMatch ? bygningMatch[1] : feil.bygning;

            return (
              <div
                key={index}
                style={{
                  padding: '15px',
                  marginBottom: '15px',
                  backgroundColor: '#ffebee',
                  border: '1px solid #f44336',
                  borderLeft: '4px solid #f44336',
                  borderRadius: '4px'
                }}
              >
                <div style={{ fontWeight: 'bold', fontSize: '16px', color: '#c62828', marginBottom: '8px' }}>
                  🏢 {bygningNavn}
                </div>

                <div style={{ fontSize: '14px', color: '#555', whiteSpace: 'pre-line' }}>
                  {feil.feil}
                </div>

                {/* Handling: Gå direkte til bygningsdel/rom */}
                <button
                  onClick={() => {
                    // Parse for å finne bygningsdel eller rom ID
                    if (feil.feil.includes('bygningsdel')) {
                      navigate(`/eiendom/${eiendomId}`);
                    } else if (feil.feil.includes('Rom:')) {
                      navigate(`/eiendom/${eiendomId}`);
                    } else {
                      navigate(`/eiendom/${eiendomId}`);
                    }
                  }}
                  style={{
                    marginTop: '10px',
                    padding: '8px 16px',
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  → Gå til befaring
                </button>
              </div>
            );
          })}
        </div>
      )}

      {/* Fullført-beskjed */}
      {erKlar && (
        <div style={{
          padding: '20px',
          backgroundColor: '#e8f5e9',
          border: '2px solid #4caf50',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <h2 style={{ color: '#2e7d32' }}>✅ Alt er i orden!</h2>
          <p style={{ fontSize: '16px' }}>
            Alle bygningsdeler og rom er fullført. Du kan nå generere rapporten.
          </p>
          <button
            onClick={() => navigate(`/eiendom/${eiendomId}`)}
            style={{
              marginTop: '15px',
              padding: '12px 24px',
              backgroundColor: '#4caf50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '500'
            }}
          >
            → Gå til eiendomsoversikt og generer rapport
          </button>
        </div>
      )}

      {/* Hurtigstatistikk */}
      <div style={{ marginTop: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h3>📊 Statistikk</h3>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginTop: '15px' }}>
          <div style={{ padding: '15px', backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #ddd' }}>
            <div style={{ fontSize: '14px', color: '#666' }}>Fremdrift</div>
            <div style={{ fontSize: '24px', fontWeight: 'bold', color: validering.prosent === 100 ? '#4caf50' : '#ff9800' }}>
              {validering.prosent}%
            </div>
          </div>

          <div style={{ padding: '15px', backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #ddd' }}>
            <div style={{ fontSize: '14px', color: '#666' }}>Mangler</div>
            <div style={{ fontSize: '24px', fontWeight: 'bold', color: antallMangler === 0 ? '#4caf50' : '#f44336' }}>
              {antallMangler}
            </div>
          </div>

          <div style={{ padding: '15px', backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #ddd' }}>
            <div style={{ fontSize: '14px', color: '#666' }}>Status</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold', color: erKlar ? '#4caf50' : '#ff9800' }}>
              {erKlar ? '✅ Klar' : '⚠️ Ikke klar'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Kontrollsenter;
